import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Company panel → Shoorah Videos: the viewing dashboard and the employee list.
 * One section covers both libraries (Health/NHS videos from Vimeo and the
 * uploaded Shoorah Vids) because they share a catalogue and an audience.
 */
const CompanyVidsLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Video Dashboard',
      path: `/${slug}/shoorah-videos`,
      description: 'Views, watch time and how far people get through a video'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/shoorah-videos/users`,
      description: `Per-${population.replace(/s$/, '')} viewing records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Shoorah Videos"
      subtitle={`Health Videos and Shoorah Vids — what your ${population} watch, and how much of it.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyVidsLayout;
